export { useAutoFocusInContainer } from "../../../../../../shared/frontend/components/hooks/useAutoFocusInContainer";
